import Vue from 'vue'

import './styles/quasar.styl'
import './css/app.styl'
import 'quasar/dist/quasar.ie.polyfills'
// import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import {
    Quasar,
    QLayout,
    QHeader,
    QFooter,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QAvatar,
    QTabs,
    QTab,
    QRouteTab,
    QForm,
    QInput,
    QCard,
    QCardSection,
    QCardActions,
    QImg,
    QSeparator,
    Notify
} from 'quasar'

Notify.setDefaults({
    position: 'bottom-right',
    timeout: 2500,
    textColor: 'primary',
    color: 'accent',
    html: false
});

Vue.use(Quasar, {
    config: {
        notify: {}
    },
    components: {
        QLayout,
        QHeader,
        QFooter,
        QDrawer,
        QPageContainer,
        QPage,
        QToolbar,
        QToolbarTitle,
        QBtn,
        QIcon,
        QList,
        QItem,
        QItemSection,
        QItemLabel,
        QAvatar,
        QTabs,
        QTab,
        QRouteTab,
        QForm,
        QInput,
        QCard,
        QCardSection,
        QCardActions,
        QSeparator,
        QImg
    },
    directives: {},
    plugins: {
        Notify
    }
})